import { createTheme } from "@mui/material/styles";
import { getThemeById, DEFAULT_THEME_ID } from "./themes";

export const buildTheme = (
  mode: "light" | "dark",
  themeId: string = DEFAULT_THEME_ID,
) => {
  const appTheme = getThemeById(themeId);
  const colors = mode === "dark" ? appTheme.dark : appTheme.light;
  return createTheme({
    palette: {
      mode,
      primary: { main: colors.primary },
      secondary: { main: colors.secondary },
      background: {
        default: colors.backgroundDefault,
        paper: colors.backgroundPaper,
      },
      text: {
        primary:
          mode === "dark" ? "rgba(255,255,255,0.95)" : "rgba(0,0,0,0.87)",
        secondary:
          mode === "dark" ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.65)",
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body2: {
        color: mode === "dark" ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.65)",
      },
    },
  });
};

export const lightTheme = buildTheme("light");
export const darkTheme = buildTheme("dark");

// Color palette for categories and group delineation (light mode)
export const categoryColors = [
  "#2196F3", // blue
  "#4CAF50", // green
  "#FF9800", // orange
  "#E91E63", // pink
  "#9C27B0", // purple
  "#00BCD4", // cyan
  "#FF5722", // deep orange
  "#607D8B", // blue grey
];

// Color palette for categories and group delineation (dark mode)
export const darkCategoryColors = [
  "#42a5f5", // blue
  "#66bb6a", // green
  "#ffa726", // orange
  "#f48fb1", // pink
  "#ce93d8", // purple
  "#4dd0e1", // cyan
  "#ff7043", // deep orange
  "#90a4ae", // blue grey
];

export const groupColors: Record<string, string> = {
  Product: "#E3F2FD", // light blue
  Design: "#F3E5F5", // light purple
  Engineering: "#E8F5E9", // light green
};

export const darkGroupColors: Record<string, string> = {
  Product: "#0d2a4a", // dark blue
  Design: "#2d1040", // dark purple
  Engineering: "#0d2a14", // dark green
};

export const groupBorderColors: Record<string, string> = {
  Product: "#1565C0",
  Design: "#6A1B9A",
  Engineering: "#2E7D32",
};

export const darkGroupBorderColors: Record<string, string> = {
  Product: "#42a5f5",
  Design: "#ce93d8",
  Engineering: "#66bb6a",
};

export const DEFAULT_MEMBER_BG_LIGHT = "#f5f5f5";
export const DEFAULT_MEMBER_BORDER_LIGHT = "#9e9e9e";
export const DEFAULT_MEMBER_BG_DARK = "#2a2a2a";
export const DEFAULT_MEMBER_BORDER_DARK = "#757575";
